import { SEARCHDEPARTMENT_FAIL, SEARCHDEPARTMENT_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const searchDepartmentReducer = (state = initialState, action) => {
	switch (action.type) {
		case SEARCHDEPARTMENT_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case SEARCHDEPARTMENT_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default searchDepartmentReducer;
